import * as tslib_1 from "tslib";
const label = [
    {
        label: '教具赠品',
    },
    {
        label: '无限回放',
    },
    {
        label: '督学辅导',
    },
];
import { Component, Vue } from 'vue-property-decorator';
let gooddService = class gooddService extends Vue {
    constructor() {
        super(...arguments);
        this.label = label;
    }
    async created() { }
};
gooddService = tslib_1.__decorate([
    Component({
        components: {},
    })
], gooddService);
export default gooddService;
